export function determineNextUntitledThreadName(currentUntitledThreadNames: string[]) {
    if (!currentUntitledThreadNames.includes("Untitled Thread")) {
        return "Untitled Thread";
    }

    let i = 2;
    while (currentUntitledThreadNames.includes(`Untitled Thread ${i}`)) {
        i++;
    }

    return `Untitled Thread ${i}`;
}
